module.exports = __webpack_public_path__ + "static/media/model-mission-8.52a5f07d.png";